<template>
  <form @submit.prevent="fazerBuscaSimples">
    <div class="busca-simples">
      <input
        type="text"
        :placeholder="contexto"
        id="inputPesquisa"
        :value="value"
        @input="updateValue($event.target.value)"
      />
      <button title="Pesquisar" type="submit" class="submit-busca-simples">
        <img
          src="../assets/images/pesquisa-preto.png"
          class="pesquisa"
          alt=" "
        />
      </button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: "",
    },
    contexto: {
      type: String,
      required: true,
    },
  },
  methods: {
    updateValue(newValue) {
      this.$emit("input", newValue);
    },
    fazerBuscaSimples() {
      this.$emit("busca-simples", this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.submit-busca-simples {
  cursor: pointer;
}

/* Posiciona a lupa de forma consistente e com folga da borda direita */
.busca-simples {
  position: relative;
}
.busca-simples .submit-busca-simples {
  position: absolute;
  top: 50%;
  right: 0.5rem; /* folga para não encostar no fim da tela */
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.busca-simples .submit-busca-simples img {
  height: 1.2rem;
  width: 1.2rem;
}

/* Cor do placeholder do input de pesquisa */
#inputPesquisa::placeholder {
  color: #adadad;
  opacity: 1; /* garante visibilidade total em alguns browsers */
}
#inputPesquisa::-webkit-input-placeholder {
  /* Chrome/Safari */
  color: #adadad;
}
#inputPesquisa::-moz-placeholder {
  /* Firefox */
  color: #adadad;
}
#inputPesquisa:-ms-input-placeholder {
  /* IE 10+ */
  color: #adadad;
}
#inputPesquisa::-ms-input-placeholder {
  /* Edge */
  color: #adadad;
}

/* Foco acessível e discreto no campo de pesquisa */
#inputPesquisa {
  outline: none;
  border: none;
  border-radius: 0.7rem; /* garante cantos arredondados do foco */
  /* Mantém o input dentro da largura disponível, incluindo paddings */
  width: 99.5%;
  box-sizing: border-box;
  /* Simetria interna do texto */
  padding-left: 0.5rem;
  /* Reserva espaço para o botão da lupa à direita */
  padding-right: 2.6rem;
}
#inputPesquisa:focus,
#inputPesquisa:focus-visible {
  outline: none;
  border: none;
  box-shadow: 0 0 0 0.3rem rgba(17, 88, 16, 0.7) !important;
  outline: 2px solid #115810; /* foco acessível */
  outline-offset: 2px;
  transition: box-shadow 0.15s ease, outline-color 0.15s ease;
}

.pesquise {
  background-color: #115810;
  padding: 0.5rem 1rem 5rem;

  label {
    color: white;
    font-size: 0.9rem;
  }

  input {
    // background-color: #d8d1d1;
    border: none;
    width: calc(100% - 0.8rem);
    height: 3rem;
    border-radius: 0.7rem 0rem 0rem 0.7rem;
    padding: 0.5rem;
    padding-left: 0.5rem;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 11.1px;
    letter-spacing: 0.03rem;
    color: black;
  }

  form {
    .campo-preenchido {
      background-color: #fffed4;
    }
  }

  .busca-simples {
    width: calc(100%);
    position: relative;
    /* o input agora controla o próprio padding via #inputPesquisa */
  }
  .botao {
    button {
      background-color: transparent;
      border: none;
      font-size: 0.9rem;
      font-family: "Poppins";
      color: #ffa900;
      padding: 0rem;
      letter-spacing: 0.03rem;
      span {
        font-size: 0.9rem;
      }
    }
    button:focus {
      box-shadow: none;
      outline: none;
      cursor: pointer;
    }
  }
  .botoes {
    float: right;
    margin: 1rem 0.2rem 1rem auto;
    button {
      margin-left: 1rem;
      padding: 0.1rem 2rem;
      font-family: "Poppins-Medium";
      font-size: 0.9rem;
    }
    button:first-child {
      background: transparent;
      border: white solid 0.15rem;
      color: white;
      padding: 0.1rem 2rem;
      cursor: pointer;
    }
    button:last-child {
      background-color: #ffa900;
      color: #2c3f2b;
      border: solid 0.15rem #ffa900;
      cursor: pointer;
    }
  }

  select {
    width: calc(100% - 0.2rem);
    height: 2rem;
    border: none;
    border-radius: 0.2rem;
    padding-left: 0.5rem;
    background-color: white;
    font-family: "Poppins";
    font-size: 1rem;
    letter-spacing: 0.04rem;
  }

  h2 {
    color: white;
    font-family: "Poppins-ExtraLight";
    font-size: 1.1rem;
    display: inline-table;
    border-bottom: #ffa900 solid 0.15rem;
    margin: 0rem;
    padding-right: 1rem;
    width: fit-content;
  }
  .row2 {
    display: grid;
    .row2mobile {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
    }
  }
  .grupo {
    border: #ffa900 solid 0.15rem;
    margin: 0.5rem 0rem;
    padding: 0.5rem 0.5rem;
    border-radius: 0.5rem;
    .data {
      display: grid;
      grid-template-columns: auto auto;
      gap: 1rem;
      .mx-datepicker {
        width: 100%;
      }
    }
    p {
      margin: 0rem;
      padding: 0rem;
      color: white;
    }
  }
  .item {
    display: grid;
    margin: 0.5rem 0rem;
    height: fit-content;
  }
  .seta {
    img {
      width: 5rem;
      position: absolute;
      right: 1.5rem;
      margin-top: 0rem;
    }
    .t-preto {
      display: none;
    }
  }
}

@media screen and (min-width: 64rem) {
  .pesquise {
    padding-bottom: 2rem !important;

    h2 {
      margin-top: 1rem;
      margin-bottom: 1rem;
    }

    .label-busca {
      text-align: left;
      margin-bottom: 0.3rem;
    }

    .row2 {
      grid-template-columns: calc(50% - 1%) calc(50% - 1%);
      gap: 2%;
      .item {
        input {
          padding-right: 0.25rem;
        }
        .gridbox-1 {
          display: grid;
        }
      }
    }

    .grupo {
      padding: 0.5rem 2rem;
    }

    .botoes {
      margin-right: 0rem;
      margin-top: 0.5rem;
      button {
        font-size: 1rem;
        padding: 0.1rem 4rem !important;
        border-radius: 0.2rem;
      }
    }

    .seta {
      img {
        right: 4.7rem;
        margin-top: 0.5rem;
      }
    }
  }
}
</style>
